import { render, staticRenderFns } from "./Cari.vue?vue&type=template&id=5325c753"
import script from "./Cari.vue?vue&type=script&lang=js"
export * from "./Cari.vue?vue&type=script&lang=js"
import style0 from "./Cari.vue?vue&type=style&index=0&id=5325c753&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports